import axiosInstance from "./axiosConfig";

export const fetchAll = async (
  page: number,
  adminQuery: {
    studentCode?: string;
    fullName?: string;
    birthday?: string;
    status?: number;
    monThi?: string;
  },
  pageSize: number
) => {
  try {
    const res = await axiosInstance.post(
      `/olympic_uet/search`,
      {
        studentCode: adminQuery.studentCode,
        fullName: adminQuery.fullName?.trim(),
        birthday: adminQuery.birthday,
        status: adminQuery.status,
        monThi: adminQuery.monThi?.trim(),
      },
      {
        params: {
          page: page,
          size: pageSize,
        },
      }
    );

    return res.data; // Trả về dữ liệu từ res
  } catch (error) {
    throw new Error("Có lỗi xảy ra khi tải dữ liệu."); // Ném lỗi để có thể xử lý ở nơi gọi
  }
};
